module.exports = __webpack_public_path__ + "static/media/kth.b2c69c56.jpg";